/**
 * @generated SignedSource<<48bcaae96b6490314d7e8a9cd4826584>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type eraseAttributionAction_OrderFragment$data = {
  readonly id: string;
  readonly purchaser: {
    readonly userId: string;
  } | null;
  readonly " $fragmentType": "eraseAttributionAction_OrderFragment";
};
export type eraseAttributionAction_OrderFragment$key = {
  readonly " $data"?: eraseAttributionAction_OrderFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"eraseAttributionAction_OrderFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "eraseAttributionAction_OrderFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Purchaser",
      "kind": "LinkedField",
      "name": "purchaser",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "userId",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Order",
  "abstractKey": null
};

(node as any).hash = "2720abcaf8181ca34e475a15c7fd7d59";

export default node;
